import { render } from "./SampleManuscriptUploader.vue?vue&type=template&id=6f321181"
import script from "./SampleManuscriptUploader.vue?vue&type=script&lang=js"
export * from "./SampleManuscriptUploader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__